export const isNotEmpty = <T extends string | number>(
  data: T | null | undefined
): data is T => {
  return data !== null && data !== undefined && data !== '' && data !== 0;
};
